export default "__VITE_ASSET__DfQHjeNz__"